// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("savage-image");

var $ = require("./lib/qsa");
var savage = require("savage-query");
var m = savage.dom;

var theater = $.one(".cheap-seats");

var disableFlicker = false;

var cue = function(s) {
  var stage = typeof s == "number" ? s : this.getAttribute("data-index");
  disableFlicker = stage >=2;
  theater.setAttribute("data-index", stage);
  $(".stage").forEach(function(s) {
    if (s.getAttribute("data-stage") == stage) {
      s.classList.add("active");
    } else {
      s.classList.remove("active");
    }
  });
};

$(".goto").forEach(el => el.addEventListener("click", cue));

var wait = function(delay, then) {
  setTimeout(then, delay);
};

var canvas = $.one(".grain");
var context = canvas.getContext("2d");
context.globalAlpha = .2;
var lastBurn = Date.now();
var invisible = false;

var flicker = function() {
  canvas.width = canvas.clientWidth;
  canvas.height = canvas.clientHeight;
  if (invisible || disableFlicker) return wait(500, flicker);
  var rand = Math.random();
  var now = Date.now();
  if (rand < .01 && now - lastBurn > 3000) {
    //cigarette burn
    context.save();
    context.scale(1, .75);
    context.beginPath();
    context.arc(canvas.width * .9, canvas.height * .1, canvas.height * .05, 0, Math.PI * 2);
    context.lineWidth = 2;
    context.stroke();
    context.fill();
    context.restore();
    wait(200, flicker);
    lastBurn = now;
  } else if (rand < .8) {
    // dust
    for (var i = 0; i < 20; i++) {
      var x = Math.random() * canvas.width;
      var y = Math.random() * canvas.height;
      context.fillRect(x, y, 2, 2);
    }
    wait(40, flicker);
  } else {
    // hairline
    var x = Math.random() * canvas.width;
    context.beginPath();
    context.moveTo(x, 0);
    context.lineTo(x, canvas.height);
    context.stroke();
    wait(50, flicker);
  }
  // var shade = Math.random() * 2 | 0;
  // shade /= 10;
  // context.fillStyle = `rgba(0, 0, 0, ${shade})`;
  // context.fillRect(0, 0, canvas.width, canvas.height);
  // context.fillStyle = "black";
};

flicker();

if ("IntersectionObserver" in window) {
  var watcher = function([e]) {
    invisible = !e.isIntersecting;
  };
  var observer = new IntersectionObserver(watcher);
  observer.observe(theater);
}